module.exports = __webpack_public_path__ + "img/mesa_hl35.17396031.png";